/**
 * SSO POST handler utility
 * Handles form POST requests to /auth endpoint similar to auth.aspx
 */

import { cookieUtils } from './cookieUtils';
import { log } from './vueLogger';

export const ssoPostHandler = {
	/**
	 * Initialize POST handler for SSO
	 * Call this in your router or main entry point
	 */
	init() {
		// Listen for form submissions to auth endpoint
		this.setupFormInterceptor();

		// Handle any existing POST data on page load
		this.handlePageLoadSSO();
	},

	/**
	 * Setup form interceptor for SSO forms
	 */
	setupFormInterceptor() {
		document.addEventListener('submit', (event) => {
			const form = event.target;

			// Check if this is an SSO form targeting auth endpoint
			if (form.action && (form.action.includes('/auth') || form.action.includes('auth.aspx'))) {
				event.preventDefault();
				this.handleFormSubmit(form);
			}
		});
	},

	/**
	 * Handle SSO form submission
	 * @param {HTMLFormElement} form - Form element
	 */
	async handleFormSubmit(form) {
		try {
			const formData = new FormData(form);
			const ssoParams = {};

			// Extract form data
			for (let [key, value] of formData.entries()) {
				ssoParams[key] = value;
			}

			log('SSO POST Handler: Processing form submission', ssoParams);

			// Set cookies (replacing auth.aspx functionality)
			cookieUtils.setSSOCookies(ssoParams);

			// Redirect to Vue SSO handler
			window.location.href = `/auth?${new URLSearchParams(ssoParams).toString()}`;
		} catch (error) {
			console.error('SSO POST Handler: Error processing form', error);
		}
	},

	/**
	 * Handle SSO data on page load (for direct POST to current page)
	 */
	handlePageLoadSSO() {
		// Check if we have SSO parameters in the current URL
		const urlParams = new URLSearchParams(window.location.search);
		const hasSSO = urlParams.has('u') || urlParams.has('i');

		if (hasSSO) {
			const ssoParams = {};
			['u', 'i', 'action', 'origin', 'd', 'r', 'm', 'rp', 'sso'].forEach((key) => {
				if (urlParams.has(key)) {
					ssoParams[key] = urlParams.get(key);
				}
			});

			if (Object.keys(ssoParams).length > 0) {
				log('SSO POST Handler: Found SSO parameters on page load', ssoParams);
				cookieUtils.setSSOCookies(ssoParams);

				// Clean URL and redirect to auth handler
				window.history.replaceState({}, '', window.location.pathname);
				setTimeout(() => {
					window.location.href = '/auth';
				}, 100);
			}
		}
	},

	/**
	 * Create SSO redirect URL
	 * @param {Object} ssoParams - SSO parameters
	 * @returns {string} - Redirect URL
	 */
	createRedirectUrl(ssoParams) {
		const baseUrl = window.location.origin;
		const params = new URLSearchParams(ssoParams);
		return `${baseUrl}/auth?${params.toString()}`;
	},
};
